import { useCallback, useSyncExternalStore } from "react";

import type { MonitoringController, UiSnapshot } from "../features/monitoring/MonitoringController.js";

/**
 * Cầu nối React ↔ `MonitoringController` — Prompt.md §31.
 *
 * `useSyncExternalStore` chứ không phải `useState` + `useEffect`: controller đã throttle sẵn
 * (2–5 FPS) và trả về **cùng một object** giữa hai lần publish, nên React tự bỏ qua re-render
 * mà không cần `memo` ở từng component. Đi qua state sẽ thêm một lớp copy và một nhịp trễ, và
 * (quan trọng hơn) sẽ mất update nào xảy ra giữa lúc mount và lúc effect chạy.
 */
export function useMonitoringSnapshot(controller: MonitoringController): UiSnapshot {
  return useSyncExternalStore(
    useCallback((onChange: () => void) => controller.subscribe(onChange), [controller]),
    useCallback(() => controller.getSnapshot(), [controller]),
  );
}
